module.exports = __webpack_public_path__ + "img/top_bg1.98a9c8dd.png";